<template>
  <div>
    <v-card class="overflow-hidden">
      <v-card-text>
        <v-row>
          <v-col>
            <customer-autocomplete-filter
              :fatherEditedCustomer="filterMonth"
              :editedCustomerIndex="-1"
              :customerName="'quotation_shortname'"
              @setFilterCustomer="setFilterCustomer"
            />
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('quotation_item_month_number')"
              v-model="filterMonth.Number"
              @input="getAllMonth"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('quotation_license_plate')"
              v-model="filterMonth.LicensePlate"
              @input="getAllMonth"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="monthDataTableHeaders"
      :items="monthList"
      class="elevation-1 mt-5"
      :loading="isLoadingMonth"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :header-props="headerProps"
      :search="searchMonth"
      :server-items-length="totalRows"
      :options="currentOptions"
      @update:options="updateOptions"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('month_tool_bar_title') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchMonth"
            append-icon="mdi-magnify"
            :label="$t('point_search_label')"
            single-line
            hide-details
            clearable
          ></v-text-field>
          <v-btn
            color="primary"
            dark
            class="mb-2 ml-8"
            @click="isShowEditMonthDialog = true"
            :disabled="isAllTextFieldDisable"
          >
            {{ $t('common_new') }}
          </v-btn>
          <v-dialog
            v-model="isShowEditMonthDialog"
            v-if="isShowEditMonthDialog"
            fullscreen
            persistent
          >
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ dialogTitleHeader }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <ValidationObserver ref="month">
                    <v-row>
                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                        <v-text-field
                          v-model="editedMonth.Number"
                          :label="$t('quotation_item_month_number')"
                          disabled
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                        <month-item-autocomplete
                          :fatherEditedItem="editedMonth"
                          :itemName="'month_number'"
                          @setEditedMonthItem="setEditedMonth"
                          v-if="editedMonthIndex === -1"
                          @keyupEnter="focusNextInput"
                          refName="monthItemAutocomplete"
                        />
                        <ValidationProvider
                          :name="$t('month_number')"
                          rules="required"
                          v-slot="{ errors }"
                          v-else
                        >
                          <v-text-field
                            v-model="editedMonth.ItemNumber"
                            disabled
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('month_number') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                        <ValidationProvider
                          :name="$t('month_name')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedMonth.ItemName"
                            disabled
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('month_name') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                        <customer-autocomplete
                          :fatherEditedCustomer="editedMonth"
                          :editedCustomerIndex="-1"
                          :customerName="'quotation_customer_number'"
                          @setCustomer="setCustomer"
                          v-if="editedMonthIndex === -1"
                          refName="customerAutocomplete"
                          @keyupEnter="focusNextInput"
                        />
                        <ValidationProvider
                          :name="$t('quotation_customer_number')"
                          rules="required"
                          v-slot="{ errors }"
                          v-else
                        >
                          <v-text-field
                            v-model="editedMonth.CustomerNumber"
                            disabled
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('quotation_customer_number') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                        <ValidationProvider
                          :name="$t('quotation_shortname')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedMonth.CustomerName"
                            disabled
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('quotation_shortname') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                        <ValidationProvider
                          :name="$t('quotation_full_name')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedMonth.CustomerFullName"
                            disabled
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('quotation_full_name') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                        <ValidationProvider
                          :name="$t('quotation_license_plate')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedMonth.LicensePlate"
                            @keyup.enter="focusNextInput"
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('quotation_license_plate') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                        <ValidationProvider
                          :name="$t('month_quantity')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedMonth.MonthQuantity"
                            @keyup.enter="focusNextInput"
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('month_quantity') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                        <date-picker-set-time
                          :time="editedMonth.StartDate"
                          :dateName="'month_start_date'"
                          :isAllTextFieldDisabled="false"
                          @setDate="setRentStartDate"
                          @keyupEnter="focusNextInput"
                        />
                        <!-- <v-text-field
                        v-model="computeRentStartDate"
                        :label="$t('month_start_date')"
                        required
                        disabled
                        v-else
                      ></v-text-field> -->
                      </v-col>
                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                        <date-picker-set-time
                          :time="editedMonth.EndDate"
                          :dateName="'month_end_date'"
                          :isAllTextFieldDisabled="false"
                          @setDate="setRentEndDate"
                          @keyupEnter="focusNextInput"
                        />
                        <!-- <v-text-field
                        v-model="computeRentEndDate"
                        :label="$t('month_end_date')"
                        required
                        disabled
                        v-else
                      ></v-text-field> -->
                      </v-col>
                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                        <date-picker-set-time-not-request
                          :time="editedMonth.StopDate"
                          :dateName="'month_stop_date'"
                          :isAllTextFieldDisabled="false"
                          @setDate="setStopDate"
                          @keyupEnter="focusNextInput"
                        />
                        <!-- <v-text-field
                        v-model="computeStopDate"
                        :label="$t('month_stop_date')"
                        required
                        disabled
                        v-else
                      ></v-text-field> -->
                      </v-col>
                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                        <date-picker-set-time
                          :time="editedMonth.DoneDate"
                          :dateName="'month_done_date'"
                          :isAllTextFieldDisabled="false"
                          @setDate="setDoneDate"
                          @keyupEnter="focusNextInput"
                        />
                        <!-- <v-text-field
                        v-model="computeDoneDate"
                        :label="$t('month_done_date')"
                        required
                        disabled
                        v-else
                      ></v-text-field> -->
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                        <ValidationProvider
                          :name="$t('month_original_currency')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedMonth.OriginalCurrency"
                            @keyup.enter="focusNextInput"
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('month_original_currency') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                        <ValidationProvider
                          :name="$t('month_domestic_currency')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedMonth.DomesticCurrency"
                            :label="$t('month_domestic_currency')"
                            @keyup.enter="focusNextInput"
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('month_domestic_currency') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                        <ValidationProvider
                          :name="$t('quotation_item_rent_warranty_period')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedMonth.RentWarrantyPeriod"
                            @change="setDay"
                            @keyup.enter="focusNextInput"
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('quotation_item_rent_warranty_period') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                        <v-text-field
                          v-model="editedMonth.RentDay"
                          :label="$t('month_rent_day')"
                          disabled
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                        <ValidationProvider
                          :name="$t('month_rent_status')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-autocomplete
                            v-model="editedMonth.MonthStatus"
                            :items="allMonthStatus"
                            item-text="Name"
                            item-value="Type"
                            :loading-text="$t('common_get_data')"
                            :no-data-text="$t('common_no_data')"
                            @keyup.enter="setMonthStatusAutocomplete"
                            ref="monthStatusAutocomplete"
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('month_rent_status') }}
                            </template>
                          </v-autocomplete>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                        <ValidationProvider
                          :name="$t('month_give_day')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedMonth.GiveDay"
                            @change="setRemoveDate"
                            @keyup.enter="focusNextInput"
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('month_give_day') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                        <v-text-field
                          v-model="computeRemoveDate"
                          :label="$t('month_expected_remove_date')"
                          disabled
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                        <v-text-field
                          v-model="editedMonth.UnUseDay"
                          :label="$t('month_not_use_day')"
                          disabled
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                        <ValidationProvider
                          :name="$t('month_use_day')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedMonth.UseDay"
                            @change="setUnUseDay"
                            @keyup.enter="focusNextInput"
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('month_use_day') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                        <date-picker-set-time
                          :time="editedMonth.LastPayDate"
                          :dateName="'month_last_pay_date'"
                          :isAllTextFieldDisabled="false"
                          @setDate="setLastPayDate"
                          @keyupEnter="focusNextInput"
                        />
                        <!-- <v-text-field
                        v-model="computeLastPayDate"
                        :label="$t('month_last_pay_date')"
                        required
                        disabled
                        v-else
                      ></v-text-field> -->
                      </v-col>
                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                        <v-checkbox
                          v-model="editedMonth.IsEnd"
                          :label="$t('month_is_end')"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </ValidationObserver>
                </v-container>
              </v-card-text>
              <v-tabs>
                <v-tab href="#tab-1">{{ $t('month_item_tab') }}</v-tab>
                <v-tab href="#tab-2">{{ $t('month_sale_item_tab') }}</v-tab>

                <v-tab-item value="tab-1">
                  <v-card flat>
                    <v-card-text>
                      <v-data-table
                        :headers="monthItemDataTableHeaders"
                        :items="editedMonth.MonthItems"
                        :search="searchMonthItem"
                        class="elevation-1"
                        :no-data-text="$t('common_no_data')"
                        :no-results-text="$t('common_no_results')"
                        :footer-props="{
                          'items-per-page-options': [30, 50, 100],
                          'items-per-page-text': $t('item_rows_per_page'),
                        }"
                      >
                        <template v-slot:top>
                          <v-toolbar flat>
                            <v-spacer></v-spacer>
                            <v-text-field
                              v-model="searchMonthItem"
                              append-icon="mdi-magnify"
                              :label="$t('quotation_item_new_install_search')"
                              single-line
                              hide-details
                              clearable
                            ></v-text-field>
                          </v-toolbar>
                        </template>
                        <template v-slot:[`item.ChangeDate`]="{ item }">
                          {{ convertToDateTimeFormat(item.ChangeDate) }}
                        </template>
                        <template v-slot:[`item.MonthItemStatus`]="{ item }">
                          {{ turnMonthItem(item.MonthItemStatus) }}
                        </template>
                        <template v-slot:[`item.NumberType`]="{ item }">
                          {{ turnNumberType(item.NumberType) }}
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item value="tab-2">
                  <v-card flat>
                    <v-card-text>
                      <v-data-table
                        :headers="saleItemDataTableHeaders"
                        :items="editedMonth.SaleItems"
                        :search="searchSaleItem"
                        class="elevation-1"
                        :no-data-text="$t('common_no_data')"
                        :no-results-text="$t('common_no_results')"
                        :footer-props="{
                          'items-per-page-options': [30, 50, 100],
                          'items-per-page-text': $t('item_rows_per_page'),
                        }"
                      >
                        <template v-slot:top>
                          <v-toolbar flat>
                            <v-spacer></v-spacer>
                            <v-text-field
                              v-model="searchSaleItem"
                              append-icon="mdi-magnify"
                              :label="$t('quotation_item_new_install_search')"
                              single-line
                              hide-details
                              clearable
                            ></v-text-field>
                          </v-toolbar>
                        </template>
                        <template v-slot:[`item.ThrowDate`]="{ item }">
                          {{ convertToDateTimeFormat(item.ThrowDate) }}
                        </template>
                        <template v-slot:[`item.StartDate`]="{ item }">
                          {{ convertToDateTimeFormat(item.StartDate) }}
                        </template>
                        <template v-slot:[`item.EndDate`]="{ item }">
                          {{ convertToDateTimeFormat(item.EndDate) }}
                        </template>
                        <template v-slot:[`item.PayType`]="{ item }">
                          {{ turnPayType(item.PayType) }}
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red darken-1"
                  text
                  @click="closeEditedMonth"
                  :disabled="isAllTextFieldDisable"
                >
                  {{ $t('common_cancel') }}
                </v-btn>
                <v-btn
                  color="green darken-1"
                  text
                  @click="saveEditedMonth"
                  :disabled="isLoadingSaveBtn"
                >
                  {{ $t('common_save') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <delete-dialog
            :isAllTextFieldDisable="isAllTextFieldDisable"
            :isLoadingSaveBtn="isLoadingDeleteBtn"
            :isShowDeleteDialog="isShowDeleteMonthDialog"
            :deleteMessage="'point_delete_dialog_message'"
            @closeDelete="closeDeleteMonth"
            @confirmDelete="confirmDeleteMonth"
          />
        </v-toolbar>
      </template>
      <!-- <template v-slot:[`item.UpdateTime`]="{ item }">
      {{ convertToDateTimeFormat(item.UpdateTime) }}
    </template> -->
      <template v-slot:[`item.Type`]="{ item }">
        {{ turnFormType(item.Type) }}
      </template>
      <template v-slot:[`item.Edit`]="{ item }">
        <v-btn icon small @click="isShowEditMonthBtn(item)">
          <v-icon>
            mdi-pencil
          </v-icon>
        </v-btn>
        <v-btn icon small @click="isShowDeleteMonthBtn(item)">
          <v-icon>
            mdi-delete
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { HttpMonth } from '@/js/http-Manager'
import CustomerAutocomplete from '@/components/CustomerAutocomplete.vue'
import CustomerAutocompleteFilter from '@/components/CustomerAutocompleteFilter.vue'
import DatePickerSetTime from '@/components/DatePickerSetTime.vue'
import DatePickerSetTimeNotRequest from '@/components/DatePickerSetTimeNotRequest.vue'
import DeleteDialog from '@/components/DeleteDialog.vue'
import MonthItemAutocomplete from '@/components/MonthItemAutocomplete.vue'
import { MonthItemStatus } from '@/js/MonthItemStatus'
import { NumberType } from '@/js/NumberType'
import { PayType } from '@/js/PayType'

export default {
  name: 'InitMonth',
  components: {
    DeleteDialog,
    MonthItemAutocomplete,
    CustomerAutocompleteFilter,
    CustomerAutocomplete,
    DatePickerSetTime,
    DatePickerSetTimeNotRequest
  },
  data: () => ({
    isShowEditMonthDialog: false,
    monthList: [],
    editedMonthIndex: -1,
    searchMonth: '',
    editedMonth: {
      Number: '',
      CustomerId: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      ItemId: '',
      ItemNumber: '',
      ItemName: '',
      LicensePlate: '',
      MonthQuantity: 0,
      StartDate: 0,
      EndDate: 0,
      StopDate: 0,
      DoneDate: 0,
      OriginalCurrency: 0,
      DomesticCurrency: 0,
      RentWarrantyPeriod: 0,
      RentDay: 0,
      MonthStatus: 0,
      GiveDay: 0,
      ExpectedRemoveDate: 0,
      UnUseDay: 0,
      UseDay: 0,
      IsEnd: false,
      LastPayDate: 0,
      MonthItems: [],
      SaleItems: []
    },
    defaultMonth: {
      Number: '',
      CustomerId: '',
      ItemId: '',
      LicensePlate: '',
      MonthQuantity: 0,
      StartDate: 0,
      EndDate: 0,
      StopDate: 0,
      DoneDate: 0,
      OriginalCurrency: 0,
      DomesticCurrency: 0,
      RentWarrantyPeriod: 0,
      RentDay: 0,
      MonthStatus: 0,
      GiveDay: 0,
      ExpectedRemoveDate: 0,
      UnUseDay: 0,
      UseDay: 0,
      IsEnd: false,
      LastPayDate: 0,
      MonthItems: [],
      SaleItems: []
    },
    isLoadingMonth: true,
    isLoadingSaveBtn: false,
    isAllTextFieldDisable: false,
    isShowDeleteMonthDialog: false,
    isLoadingDeleteBtn: false,
    isDeleteBtnDisable: false,
    currentOptions: {
      page: 1,
      itemsPerPage: 30,
      sortBy: [],
      sortDesc: [],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      triggerByOutsite: true
    },
    isUpdateEventTotal: true,
    totalRows: 0,
    filterMonth: {
      Number: '',
      CustomerId: '',
      LicensePlate: ''
    },
    searchMonthItem: '',
    searchSaleItem: '',
    allMonthStatus: []
  }),
  async mounted () {
    await this.getAllMonth()
    await this.countTotalRows()
    await this.getAllMonthStatus()
  },
  computed: {
    monthDataTableHeaders () {
      return [
        {
          text: this.$t('quotation_item_month_number'),
          align: 'start',
          value: 'Number'
        },
        { text: this.$t('quotation_customer_number'), align: 'start', value: 'CustomerNumber' },
        { text: this.$t('quotation_shortname'), align: 'start', value: 'CustomerName' },
        { text: this.$t('quotation_full_name'), align: 'start', value: 'CustomerFullName' },
        { text: this.$t('item_number'), align: 'start', value: 'ItemNumber' },
        { text: this.$t('item_name'), align: 'start', value: 'ItemName' },
        {
          text: this.$t('quotation_license_plate'),
          align: 'start',
          value: 'LicensePlate'
        },
        {
          text: this.$t('common_look'),
          align: 'center',
          value: 'Edit',
          sortable: false
        }
      ]
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },

    dialogTitleHeader () {
      return this.editedMonthIndex === -1
        ? this.$t('point_new_card_title')
        : this.$t('point_edited_card_title')
    },
    computeRentStartDate () {
      return this.convertToDateTimeFormat(this.editedMonth.StartDate)
    },
    computeRentEndDate () {
      return this.convertToDateTimeFormat(this.editedMonth.EndDate)
    },
    computeStopDate () {
      return this.convertToDateTimeFormat(this.editedMonth.StopDate)
    },
    computeDoneDate () {
      return this.convertToDateTimeFormat(this.editedMonth.DoneDate)
    },
    computeLastPayDate () {
      return this.convertToDateTimeFormat(this.editedMonth.LastPayDate)
    },
    computeRemoveDate () {
      return this.convertToDateTimeFormat(this.editedMonth.ExpectedRemoveDate)
    },
    monthItemDataTableHeaders () {
      return [
        {
          text: this.$t('month_item_change_date'),
          align: 'start',
          value: 'ChangeDate'
        },
        { text: this.$t('month_item_status'), align: 'start', value: 'MonthItemStatus' },
        { text: this.$t('quotation_shortname'), align: 'start', value: 'CustomerName' },
        { text: this.$t('quotation_full_name'), align: 'start', value: 'CustomerFullName' },
        {
          text: this.$t('quotation_license_plate'),
          align: 'start',
          value: 'LicensePlate'
        },
        { text: this.$t('month_quantity'), align: 'start', value: 'MonthQuantity' },
        {
          text: this.$t('month_item_is_throw_sale_detail'),
          align: 'start',
          value: 'IsThrowSaleDetail'
        },
        { text: this.$t('month_item_original_number'), align: 'start', value: 'NumberType' },
        { text: this.$t('month_sale_item_tab'), align: 'start', value: 'OriginalNumber' }
      ]
    },
    saleItemDataTableHeaders () {
      return [
        {
          text: this.$t('month_sale_item_settle_day'),
          align: 'start',
          value: 'SettleDay'
        },
        { text: this.$t('month_original_currency'), align: 'start', value: 'OriginalCurrency' },
        { text: this.$t('month_domestic_currency'), align: 'start', value: 'DomesticCurrency' },
        {
          text: this.$t('month_sale_item_sale_type'),
          align: 'start',
          value: 'SaleType'
        },
        { text: this.$t('month_sale_item_sale_number'), align: 'start', value: 'SaleNumber' },
        { text: this.$t('month_sale_item_sale_sort'), align: 'start', value: 'SaleSort' },
        { text: this.$t('month_sale_item_throw_date'), align: 'start', value: 'ThrowDate' },
        { text: this.$t('month_sale_item_start_date'), align: 'start', value: 'StartDate' },
        { text: this.$t('month_sale_item_end_date'), align: 'start', value: 'EndDate' },
        { text: this.$t('month_sale_item_pay_day'), align: 'start', value: 'PayDay' },
        { text: this.$t('month_sale_item_pay_type'), align: 'start', value: 'PayType' },
        { text: this.$t('quotation_customer_number'), align: 'start', value: 'CustomerNumber' },
        { text: this.$t('quotation_shortname'), align: 'start', value: 'CustomerName' },
        { text: this.$t('quotation_full_name'), align: 'start', value: 'CustomerFullName' },
        { text: this.$t('quotation_license_plate'), align: 'start', value: 'LicensePlate' },
        { text: this.$t('month_quantity'), align: 'start', value: 'MonthQuantity' },
        { text: this.$t('quotation_item_remark'), align: 'start', value: 'Remark' }
      ]
    }
  },
  methods: {
    setMonthStatusAutocomplete (event) {
      this.$refs.monthStatusAutocomplete.isMenuActive = false
      this.$refs.monthStatusAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (form[i].type !== 'hidden' && !form[i].disabled && form[i].type !== 'checkbox') {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    async getAllMonthStatus () {
      let response = await HttpMonth.GetMonthStatus()
      this.allMonthStatus = response.status === 200 ? response.data.Data : []
    },
    turnNumberType (val) {
      return NumberType.NumberTypeName(val)
    },
    turnPayType (val) {
      return PayType.PayTypeName(val)
    },
    turnMonthItem (val) {
      return MonthItemStatus.MonthItemStatusName(val)
    },
    setUnUseDay () {
      this.editedMonth.UnUseDay = this.editedMonth.RentDay - this.editedMonth.UseDay
    },
    setRemoveDate () {
      let temp = new Date(this.editedMonth.EndDate)
      this.editedMonth.ExpectedRemoveDate = temp.setDate(
        temp.getDate() + this.editedMonth.GiveDay * 1
      )
    },
    setDay () {
      if (this.editedMonth.DoneDate !== 0 && this.editedMonth.RentWarrantyPeriod !== 0) {
        let doneYear = new Date(this.editedMonth.DoneDate).getFullYear()
        var year = this.editedMonth.RentWarrantyPeriod / 12
        this.editedMonth.RentDay = year * 365
        for (let index = 0; index <= year; index++) {
          if (
            ((doneYear + index) % 4 === 0 && (doneYear + index) % 100 !== 0) ||
            (doneYear + index) % 400 === 0
          ) {
            this.editedMonth.RentDay++
          }
        }
      }
      this.setUnUseDay()
    },
    async setFilterCustomer (val) {
      this.filterMonth.CustomerId = val.Id
      this.filterMonth = JSON.parse(JSON.stringify(this.filterMonth))
      await this.getAllMonth()
      await this.countTotalRows()
    },
    setLastPayDate (val) {
      this.editedMonth.LastPayDate = val * 1
    },
    setStopDate (val) {
      this.editedMonth.StopDate = val * 1
    },
    setDoneDate (val) {
      this.editedMonth.DoneDate = val * 1
      this.setDay()
    },
    setRentEndDate (val) {
      this.editedMonth.EndDate = val * 1
      this.setRemoveDate()
    },
    setRentStartDate (val) {
      this.editedMonth.StartDate = val * 1
    },
    setCustomer (val) {
      this.editedMonth.CustomerId = val.Id
      this.editedMonth.CustomerNumber = val.Number
      this.editedMonth.CustomerName = val.ShortName
      this.editedMonth.CustomerFullName = val.FullName
      this.editedMonth = JSON.parse(JSON.stringify(this.editedMonth))
    },
    setEditedMonth (val) {
      this.editedMonth.ItemId = val.Id
      this.editedMonth.ItemNumber = val.Number
      this.editedMonth.ItemName = val.Name
      this.editedMonth.ItemUnit = val.Unit
      this.editedMonth = JSON.parse(JSON.stringify(this.editedMonth))
    },
    async getAllMonth (val) {
      if (this.isUpdateEventTotal) {
        this.currentOptions.page = 1
        this.countTotalRows()
      }
      this.isUpdateEventTotal = true
      this.isLoadingMonth = true
      let param = {
        Number: this.filterMonth.Number,
        CustomerId: this.filterMonth.CustomerId,
        LicensePlate: this.filterMonth.LicensePlate,
        ItemsPerPage:
          typeof val === 'object' && val ? val.itemsPerPage : this.currentOptions.itemsPerPage,
        Page: typeof val === 'object' && val ? val.page : this.currentOptions.page,
        SortBy: typeof val === 'object' && val ? val.sortBy[0] : this.currentOptions.sortBy,
        SortDesc: typeof val === 'object' && val ? val.sortDesc[0] : this.currentOptions.sortBy
      }
      let response = await HttpMonth.GetMonth(param)
      this.isLoadingMonth = false
      this.monthList = response.status === 200 ? response.data.Data : []
    },
    async countTotalRows () {
      if (this.isUpdateEventTotal) {
        let param = {
          Number: this.filterMonth.Number,
          CustomerId: this.filterMonth.CustomerId,
          LicensePlate: this.filterMonth.LicensePlate
        }

        let response = await HttpMonth.GetMonthCount(param)
        this.totalRows = response.status === 200 ? response.data.Data : 0
      }
    },
    updateOptions (val) {
      this.currentOptions = val
      this.isUpdateEventTotal = false
      this.getAllMonth(val)
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    isShowEditMonthBtn (item) {
      this.editedMonthIndex = this.monthList.indexOf(item)
      this.editedMonth = JSON.parse(JSON.stringify(item))
      this.isShowEditMonthDialog = true
    },
    closeEditedMonth () {
      this.isShowEditMonthDialog = false
      this.isLoadingSaveBtn = false
      this.isAllTextFieldDisable = false

      this.$nextTick(() => {
        this.editedMonth = JSON.parse(JSON.stringify(this.defaultMonth))
        this.editedMonthIndex = -1
      })
    },

    async saveEditedMonth () {
      const isValid = await this.$refs.month.validate()
      if (isValid) {
        this.isLoadingSaveBtn = true
        this.isAllTextFieldDisable = true
        this.isLoadingMonth = true
        if (this.editedMonthIndex !== -1) {
          await HttpMonth.UpdateMonth(this.editedMonth)
        } else {
          await HttpMonth.AddMonth(this.editedMonth)
        }
        await this.getAllMonth()
        this.closeEditedMonth()
      }
    },
    isShowDeleteMonthBtn (item) {
      this.editedMonthIndex = this.monthList.indexOf(item)
      let str = JSON.stringify(item)
      this.editedMonth = JSON.parse(str)
      this.isShowDeleteMonthDialog = true
    },
    async confirmDeleteMonth () {
      this.isLoadingDeleteBtn = true
      this.isDeleteBtnDisable = true
      this.isLoadingMonth = true
      // await HttpPoint.DeletePoint(this.monthList[this.editedMonthIndex].Id)
      this.isLoadingDeleteBtn = false
      this.isDeleteBtnDisable = false
      this.isLoadingMonth = false
      await this.getAllMonth()
      this.closeDeleteMonth()
    },

    closeDeleteMonth () {
      this.isShowDeleteMonthDialog = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultMonth)
        this.editedMonth = JSON.parse(str)
        this.editedMonthIndex = -1
      })
    }
  }
}
</script>
